import {sendLog} from "logger/api"
import {getBlockApiF} from "dbot/src/app/DbotAppLight"
import * as R from "ramda";

export const loggerMiddleware = ({getState}) => {
    return next => action => {
        const clientId = getState().clientId;
        const dbotReducer = getState().dbotReducer;
        const records = dbotReducer.records;
        const block = getBlock(records);
        const lastBoxId = getLastBoxId(records, dbotReducer.apis);
        if (action.toLog) {
            if (action.toLog.loggerArray && action.toLog.loggerArray.length > 0) {
                action.toLog.loggerArray.map(logger => sendLog(buildLog(logger, block, action.toLog, lastBoxId, clientId)))
            }
            sendLog(buildLog(undefined, block, action.toLog, lastBoxId, clientId));
        }
        else if (action.type === 'ADD_AND_INIT_BLOCK' && records.length === 0) {
            sendLog({eventName : 'load-page', category : 'page', clientId})
        }
        return next(action)
    }
}

const buildLog = (logger, block, toLog, lastBoxId, clientId) => {
    const log = {
        eventName : !logger ? toLog.eventName : 'chat-tag',
        elementId : toLog.elemId,
        category : toLog.category,
        block,
        tagName : logger ? logger.code : toLog.tagName ? toLog.tagName : undefined,
        tagValue : logger ? logger.value : toLog.tagValue ? toLog.tagValue : undefined,
        interaction : lastBoxId,
        clientId
    }
    return log;
}

const getBlock = (records) => {
    if (records === null || records.length < 1) {
        return undefined;
    }
    return records[records.length - 1].block;
}

const getLastBoxId = (records, apis) => {
    for (let record of R.reverse(records)) {
        let api = getBlockApiF(apis)(record.block);
        let node = api.getNode(record.id);
        if (node.type === 'button-box') return node.id;
    }
    return null;
}